import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${space}
  ${layout}
`;

const HourglassSVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="hourglass-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox={`0 0 11 14`}
        data-testid="hourglass-svg"
      >
        <path
          fill="#FFF"
          d="M5.5 5.688c-1.655 0-2.98-1.82-2.98-3.938h5.96c0 2.131-1.333 3.938-2.98 3.938m4.813-3.938c.38 0 .687-.294.687-.656V.656C11 .294 10.692 0 10.312 0H.688C.307 0 0 .294 0 .656v.438c0 .362.308.656.688.656 0 2.487 1.46 4.586 3.461 5.25-2 .664-3.462 2.763-3.462 5.25-.38 0-.687.294-.687.656v.438c0 .362.308.656.688.656h9.624c.38 0 .688-.294.688-.656v-.438c0-.362-.308-.656-.688-.656 0-2.487-1.46-4.586-3.461-5.25 2-.664 3.462-2.763 3.462-5.25"
        />
      </svg>
    </StyledContainer>
  );
};

export default HourglassSVG;
